import { render, staticRenderFns } from "./IncomesByCategoryDonut.vue?vue&type=template&id=4827bbc3&scoped=true"
import script from "./IncomesByCategoryDonut.vue?vue&type=script&lang=js"
export * from "./IncomesByCategoryDonut.vue?vue&type=script&lang=js"
import style0 from "./IncomesByCategoryDonut.vue?vue&type=style&index=0&id=4827bbc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827bbc3",
  null
  
)

export default component.exports